import { gql } from "@grandvisionhq/graphql";
import recentOrdersResultsFragment from "../../../../fragments/Profile/operations/fragments/recent-orders.js";
const GET_RECENT_ORDERS = gql`
  query getRecentOrders {
    me {
      id
      orders(offset: 0, limit: 2) {
        results {
          ...RecentOrderResultsFragment
        }
      }
    }
  }
  ${recentOrdersResultsFragment}
`;
export {
  GET_RECENT_ORDERS as default
};
//# sourceMappingURL=get-recent-orders.js.map
